/*
 * @Description: page 模块
 * @Author: shufei
 * @Date: 2021-11-08 21:44:08
 * @LastEditTime: 2024-8-13
 * @LastEditors: zdy
 */
import Cookies from 'js-cookie'
import wx from 'weixin-js-sdk'
const state = {
  initLink: '',
  isLoading: null,
  sdkInfo: {},
  userId: '',
  token: '',
  zoneId: '',
  supplierId: '0',
  corpId: ''
}
const mutations = {
  SET_ZONEID: (state, zoneId) => {
    state.zoneId = zoneId
    localStorage.setItem('zoneId', zoneId)
  },
  SET_SUPPLIERID: (state, supplierId) => {
    state.supplierId = supplierId
    localStorage.setItem('supplierId', supplierId)
  },
  SET_CORPID: (state, corpId) => {
    state.corpId = corpId
    localStorage.setItem('corpId', corpId)
  },
  SET_TOKEN: (state, token) => {
    state.token = token
    // Cookies.remove('bcssToken')
    Cookies.set('bcssToken', token)
    localStorage.setItem('token', token)
  }
}
const actions = {
  
}
const getters = {}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
